<template>
  <div>
    <Loading />
    <div id="YtPlayer"></div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from './loader-player.vue';
// import { addListener, launch } from 'devtools-detector';

import { initCustomPlayer } from '/assets/global/js/custom_player.js';
import decrypt from '../decrypt';
export default {
  name: 'player',
  components: {
    Loading,
  },
  props: {
    watch: {
      type: Boolean | Number,
      default: false,
    },
    poster: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    encrypted: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      exItem: null,
    };
  },
  created() {
    this.decryptItem(this.encrypted)
      .then((response) => {
        this.exItem = response.data.item;

        const item = decrypt(this.exItem);
        this.initPlayer(item.content, item.status);
      })
      .catch((error) => {
        console.error('Decryption failed:', error);
      });
  },
  mounted() {
    // addListener((isOpen) => {
    //   if (isOpen) {
    //     const url = '/';
    //     window.location.href = url;
    //   }
    // });
    // launch();
  },

  methods: {
    decryptItem(item) {
      const apiUrl = `/decrypt-item`;
      return axios.post(apiUrl, {
        item: item,
      });
    },

    onError(error) {
      console.error('Error code', error.code, 'object', error);
    },

    initPlayer(url, isLive) {
      const plugin = document.createElement('script');
      plugin.setAttribute(
        'src',
        '/assets/global/fwdev-player/java/java/FWDEVPlayer.js',
      );
      plugin.async = true;
      plugin.onload = () => {
        console.log('Script loaded');
        if (typeof FWDEVPlayer !== 'undefined') {
          initCustomPlayer(url, undefined, this.poster, isLive);
        } else {
          console.error('FWDEVPlayer is not defined.');
        }
      };
      plugin.onerror = (error) => {
        console.error('Script failed to load:', error);
      };
      document.head.appendChild(plugin);
    },
  },
};
</script>

<style scoped>
#YtPlayer {
  border-radius: 10px;
}
</style>
